export const FOOTER_TYPE = {
	ACCOUNT: 'account',
	ADMIN: 'admin',
	AUTHENTICATION: 'authentication',
	BLOG: 'blog',
	CELLAR: 'cellar',
	CHECKOUT: 'checkout',
	DEFAULT: 'default',
	LANDING: 'landing',
	PRIMEUR: 'primeur',
	PRIMEUR_CHECKOUT: 'primeur-checkout',
};
